import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { volumes } from '../../data/volumes';
const toneClass: Record<string, string> = {
  rose: 'text-rose-dark',
  sage: 'text-sage-dark',
  honey: 'text-honey-dark'
};
export function VolumesSection() {
  return <section className="bg-cream px-5 py-20 md:py-28" data-id="element-187" data-mp="2mx9flzdaskqu">
      <div className="mx-auto max-w-6xl" data-id="element-188" data-mp="2rsosanzkkalo">
        <SectionHeading title={<>5 volúmenes. <span className="text-rose-dark" data-id="element-190" data-mp="2e2bjykirmtvt">Un solo sistema</span> para acompañar esta etapa.</>} data-id="element-189" data-mp="2rvt5ubyxcip0" />
        <ol className="mt-14 border-b border-line" data-id="element-191" data-mp="2itjujjvu0lak">
          {volumes.map(v => <li key={v.number} className="grid gap-4 border-t border-line py-8 md:grid-cols-[88px_1fr] lg:grid-cols-[88px_1fr_260px] lg:items-start lg:gap-8" data-id="element-192" data-mp="244fdw74oqp4k">
              <span className={`font-serif text-5xl leading-none tabular-nums md:text-6xl ${toneClass[v.tone]}`} data-id="element-193" data-mp="29409q8ok6hd2">{v.number}</span>
              <div data-id="element-194" data-mp="1v63f3hto0l11">
                <h3 className="font-serif text-xl uppercase leading-snug text-ink md:text-2xl" data-id="element-195" data-mp="1z52njceluzx8">{v.title}</h3>
                <p className="mt-2 text-base font-semibold text-ink md:text-lg" data-id="element-196" data-mp="1fiqqfal5blat">{v.tagline}</p>
                <p className="mt-2 max-w-2xl text-base leading-relaxed text-ink-muted md:text-lg" data-id="element-197" data-mp="1akp0c5paylpu">{v.body}</p>
              </div>
              <p className="text-xs font-bold uppercase leading-relaxed tracking-wider text-sage-dark md:col-start-2 md:text-sm lg:col-start-auto lg:pt-2 lg:text-right" data-id="element-198" data-mp="1pg4z2o0tv5sk">
                {v.flow.join(' → ')}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}